<template>
  <img :src="icon" alt="" class="battery-icon" />
</template>
<script setup lang="ts">
import icon from './BatteryIcon.svg';
</script>
